import React from 'react';
import reactLogo from '../images/logo.svg';

function Footer() {
  const year = (new Date().getFullYear());
  return (
    <footer className="Footer">
      <p>&copy; {year} chad-espelage.com. All rights reserved.</p>
      <p>This site was built with React.js<img src={reactLogo} className="React-logo" alt="React JS" /></p>
    </footer>
  );
}

export default Footer;
